"use client";
import { ProcessStatusType } from "@/@types/general";
import {
  TerritoryAreaType,
  TerritoryBranchType,
  TerritoryCityType,
  TerritoryClusterType,
  TerritoryRegionalType,
} from "@/@types/response";
import { get_territory } from "@/libs/territory";
import { create } from "zustand";

interface Eligibilitystore {
  areas: TerritoryAreaType[] | null;
  regions: TerritoryRegionalType[] | null;
  branches: TerritoryBranchType[] | null;
  clusters: TerritoryClusterType[] | null;
  cities: TerritoryCityType[] | null;
  status: ProcessStatusType;
  get_all_territory: () => Promise<void>;
}
export const useEligibilitystore = create<Eligibilitystore>((set, get) => ({
  areas: null,
  regions: null,
  branches: null,
  clusters: null,
  cities: null,
  status: "",
  get_all_territory: async () => {
    set((prev) => ({ ...prev, status: "loading" }));
    const areas =
      get().areas ??
      (await get_territory<"areas", TerritoryAreaType>("areas")).data?.areas ??
      null;
    const regions =
      get().regions ??
      (await get_territory<"regions", TerritoryRegionalType>("regions")).data
        ?.regions ??
      null;
    const branches =
      get().branches ??
      (await get_territory<"branches", TerritoryBranchType>("branches")).data
        ?.branches ??
      null;
    const clusters =
      get().clusters ??
      (await get_territory<"clusters", TerritoryClusterType>("clusters")).data
        ?.clusters ??
      null;
    const cities =
      get().cities ??
      (await get_territory<"cities", TerritoryCityType>("cities")).data
        ?.cities ??
      null;
    set(() => ({
      status: "success",
      areas: areas,
      regions: regions,
      branches: branches,
      clusters: clusters,
      cities: cities,
    }));
  },
}));
